import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const TreeButton: React.FC<Props> = React.memo(({ children, ...props }) => {
  return (
    <button type="button" {...props}>
      {children}
    </button>
  );
});

export default TreeButton;
